module.exports = __webpack_public_path__ + "img/1_036.1429e524.jpg";